// extracted by mini-css-extract-plugin
export default {"launcher":"bl_Px","launcher__heading":"bl_Py","launcher__menu-item":"bl_Pz","launcher__options":"bl_PB","launcher__framework-style__select":"bl_PC form-control"};